<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
      >
        <v-alert
          v-for="(item, index) in storeErrors"
          :key="index"
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
        >
          {{ item[0] }}
        </v-alert>
        <v-text-field
          v-model="unit"
          outlined
          dense
          hide-details="auto"
          label="Unit"
        />
      </v-col>
      <v-col
        cols="12"
      >
        <v-text-field
          v-model="description"
          outlined
          dense
          hide-details="auto"
          label="Description"
        />
      </v-col>
      <v-col
        cols="12"
      >
        <v-btn
          color="primary"
          block
          :loading="storing"
          @click="initStore"
        >
          <v-icon left>
            mdi-content-save
          </v-icon>
          Save
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    name: 'VUnitCreate',
    data () {
      return {
        unit: null,
        description: null,
      }
    },
    computed: {
      ...mapState({
        storing: state => state.unit.storing,
        storeErrors: state => state.unit.storeErrors,
        storeSuccess: state => state.unit.storeSuccess,
      }),
    },
    watch: {
      storeSuccess (val) {
        if (val) {
          this.unit = null
          this.description = null
        }
      },
    },
    methods: {
      ...mapActions({
        store: 'unit/store',
      }),
      initStore () {
        this.store({
          unit: this.unit,
          description: this.description,
        })
      },
    },
  }
</script>
